var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.0273438,
    width: 32,
    height: 32,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13H10.5V22H24.5V13Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.75C18.1904 18.75 18.75 18.1904 18.75 17.5C18.75 16.8096 18.1904 16.25 17.5 16.25C16.8096 16.25 16.25 16.8096 16.25 17.5C16.25 18.1904 16.8096 18.75 17.5 18.75Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13V9C21.5 7.93913 21.0786 6.92172 20.3284 6.17157C19.5783 5.42143 18.5609 5 17.5 5C16.4391 5 15.4217 5.42143 14.6716 6.17157C13.9214 6.92172 13.5 7.93913 13.5 9V13",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 28C13.3284 28 14 27.3284 14 26.5C14 25.6716 13.3284 25 12.5 25C11.6716 25 11 25.6716 11 26.5C11 27.3284 11.6716 28 12.5 28Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28C18.3284 28 19 27.3284 19 26.5C19 25.6716 18.3284 25 17.5 25C16.6716 25 16 25.6716 16 26.5C16 27.3284 16.6716 28 17.5 28Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28C23.3284 28 24 27.3284 24 26.5C24 25.6716 23.3284 25 22.5 25C21.6716 25 21 25.6716 21 26.5C21 27.3284 21.6716 28 22.5 28Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28C28.3284 28 29 27.3284 29 26.5C29 25.6716 28.3284 25 27.5 25C26.6716 25 26 25.6716 26 26.5C26 27.3284 26.6716 28 27.5 28Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 28C8.32843 28 9 27.3284 9 26.5C9 25.6716 8.32843 25 7.5 25C6.67157 25 6 25.6716 6 26.5C6 27.3284 6.67157 28 7.5 28Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.f64d79f7.svg";
export { ForwardRef as ReactComponent };